import React from 'react';
import {StaffLayout} from 'components/Layout';

const FirmsListLazy = React.lazy(() => import(/* webpackChunkName: "FirmsList" */ './FirmsList'));
const FirmEditLazy = React.lazy(() => import(/* webpackChunkName: "FirmEdit" */ './FirmEdit'));

export const FirmsList = props => <StaffLayout component={FirmsListLazy} {...props} />;
export const FirmEdit = props => <FirmEditLazy {...props} />;
